module.exports = __webpack_public_path__ + "static/media/step_8.13691d96.png";